export default __webpack_public_path__ + "static/media/rt_intro.bf6a92bd.png";